import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import * as Func from "../../../../helpers/functions";
import * as HMS from "../../common/component/Index";
import DEFINE, { FEATURE_FLAGS, TAG_GROUP_SITE_TYPE } from "../../../../constants/Define";
import CategoryList from "./CategoryList";
import Wrapper from "containers/backend/common/component/Wrapper";
import AntSelect, {
  AntOption,
} from "containers/backend/common/component/AntSelect";
import Span from "containers/backend/common/component/Span";
import CategoryListWithDrag from "./CategoryListWithDrag";
import { isEqual } from "lodash";
import { Tabs } from "antd";
import "./styles.less";

class SupplierCategoryVW extends Component {
  state = {
    filters: {
      pageSize: this.props.vinwonderTagGroupState.pageSize,
      pageIndex: this.props.vinwonderTagGroupState.pageIndex,
      siteType: TAG_GROUP_SITE_TYPE.PRODUCT_LISTING
    },
    permisionActions: [],
    supplierCategories: this.props.vinwonderTagGroupState.supplierCategories,
    supplierId: null,
    listVWTagGroupAll: this.props.vinwonderTagGroupState.listVWTagGroupAll,
    vwTagGroupSiteType: TAG_GROUP_SITE_TYPE.PRODUCT_LISTING
  };

  componentDidMount() {
    this.setState({
      permisionActions: Func.getPermissionActions(
        DEFINE.GENERAL.ROUTE_NAME.TAG_GROUP_VW
      ),
    });
    this.props.getVinwonderTagGroupListAll(this.state.filters);
    this.props.getListSuppliers({siteType: TAG_GROUP_SITE_TYPE.PRODUCT_LISTING});
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.vinwonderTagGroupState.listVWTagGroupAll &&
      !isEqual(
        nextProps.vinwonderTagGroupState.listVWTagGroupAll,
        this.props.vinwonderTagGroupState.listVWTagGroupAll
      )
    ) {
      this.setState({
        listVWTagGroupAll: nextProps.vinwonderTagGroupState.listVWTagGroupAll,
      });
    }
  }

  render() {
    const { t } = this.props;
    const {
      isFetching,
      totalCount,
      totalPage,
      pageIndex,
      pageSize,
      supplierCategories,
    } = this.props.vinwonderTagGroupState;
    const pagination = {
      totalCount,
      totalPage,
      defaultCurrent: pageIndex,
      pageSize,
    };
    const { permisionActions, listVWTagGroupAll } = this.state;
    return (
      <Fragment>
        <HMS.PageListComponent
          onChangeLanguage={
            FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage
          }
        >
          <HMS.HeaderListComponent
            path={this.props.match.path}
            groupPath={"category"}
            titleHeader={t("navigation.categoryvw")}
            componentRight={
              <Fragment>
                {permisionActions && permisionActions.allowCreate && (
                  <Link to={`/tag-group-vw/action`} className="btn btn-primary">
                    + {t(`action.create`)}
                  </Link>
                )}
              </Fragment>
            }
          />
          <Tabs className="tabs-sitetype" defaultActiveKey={TAG_GROUP_SITE_TYPE.PRODUCT_LISTING} onChange={this.onChangeTab}>
            <Tabs.TabPane tab={<span>Product Listing</span>} key={TAG_GROUP_SITE_TYPE.PRODUCT_LISTING} />
            <Tabs.TabPane tab={<span>Microsite</span>} key={TAG_GROUP_SITE_TYPE.MICROSITE} />
          </Tabs>
          <div className="wrapper-content-taggroup-vw">
            <Wrapper
              className="row col-md-12 p-2"
              style={{ marginBottom: "2rem" }}
            >
              <Wrapper className="col-md-4">
                <Span>{t("item.vinwondertaggroup.filterFollowSupplier")}:</Span>
                <AntSelect
                  className="select-departure"
                  showArrow
                  showSearch
                  placeholder={"Filter theo NCC"}
                  value={this.state.supplierId}
                  onChange={(value) => this.onChangeSupplier(value)}
                  style={{ width: "100%" }}
                  filterOption={this.selectFilterSearch}
                >
                  <AntOption value={null}>Tất cả</AntOption>
                  {(supplierCategories || []).map((d) => (
                    <AntOption key={d.id} value={d.id}>
                      {d.name} - ({d.totalTagConfiged} Tags)
                    </AntOption>
                  ))}
                </AntSelect>
              </Wrapper>
            </Wrapper>
            {this.state.supplierId ? (
              <CategoryListWithDrag
                permisions={permisionActions}
                supplierId={this.state.supplierId}
                dataRender={listVWTagGroupAll}
                onDragToOrder={this.props.dragToOrderAction}
                onUpdateDefaultTag={this.props.updateDefaultTagInSupplier}
                siteType={this.state.vwTagGroupSiteType}
              />
            ) : (
              <CategoryList
                loading={isFetching}
                permisions={permisionActions}
                supplierCategories={listVWTagGroupAll}
                onDeleteSupplierCategory={this.onDeleteSupplierCategory}
                pagination={pagination}
                onChange={this.onTableChange}
                onLockRateCode={this.lockRateCode}
              />
            )}
          </div>
        </HMS.PageListComponent>
      </Fragment>
    );
  }

  onChangeLanguage = () => {
    this.props.getVinwonderTagGroupListAll(this.state.filters);
  };

  onTableChange = (pagination, filters, sorter) => {
    let newFilters = Func.genaratePaginateFilterSort(
      pagination,
      filters,
      sorter
    );
    this.setState({
      filter: newFilters,
    });
    this.props.getVinwonderTagGroupListAll(newFilters);
  };

  onDeleteSupplierCategory = (category) => {
    this.props.deleteSupplierCategoryAction(category, this.state.filters);
  };

  onChangeTab = (key) => {
    this.props.getVinwonderTagGroupListAll({
      pageSize: this.props.vinwonderTagGroupState.pageSize,
      pageIndex: this.props.vinwonderTagGroupState.pageIndex,
      siteType: key
    });
    this.props.getListSuppliers({siteType: key});
    this.setState({ vwTagGroupSiteType: key, supplierId: null });
  };

  onChangeSupplier = (value) => {
    this.setState({ supplierId: value });
    this.props.getVinwonderTagGroupListAll(
      value ? { supplierId: value, siteType: this.state.vwTagGroupSiteType } : this.state.filters
    );
  };

  getOptionSearchText = (children) => {
    if (children === null || children === undefined) {
      return "";
    }

    if (typeof children === "string" || typeof children === "number") {
      return String(children);
    }

    if (Array.isArray(children)) {
      return children.map(this.getOptionSearchText).join(" ");
    }

    if (React.isValidElement(children)) {
      return this.getOptionSearchText(children.props.children);
    }

    return "";
  };

  selectFilterSearch = (input, option) => {
    const optionText = Func.vietnameseStringToUnicode(
      this.getOptionSearchText(option?.props?.children).toLowerCase()
    );
    const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
    return optionText.indexOf(inputText) >= 0;
  };
}

export default SupplierCategoryVW;
